import "@usb-shield/themes/dist/library/styles/reset.scss";
import "@repo/ui/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "#App.tsx"; // Create a new router instance

// biome-ignore lint/style/noNonNullAssertion: <explanation>
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
